import actionTypes from './index';

export default itemId => ({ type: actionTypes.REMOVE_ITEM, payload: { itemId } });
